'use client';
import LoadingSpinner from '@c/LoadingSpinner';
import { useAuth } from 'context/AuthContext';
import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

export default function FetchUser() {
  const { user } = useAuth();
  const params = useSearchParams();
  useEffect(() => {
    if (user) {
      const redirect = params?.get('redirect');
      if (redirect) {
        window.location.href = redirect;
      }
    } else if (user === null) {
      const redirect = params?.get('redirect');
      window.location.href = '/login?redirect=' + encodeURI(redirect ?? '/');
    }
  }, [user]);
  return <LoadingSpinner />;
}
